// Analytics utilities for game metrics
import { logEvent } from 'firebase/analytics';
import { analytics } from '../lib/firebase';

// Game-specific events
export const trackGameEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (!analytics) return;
  
  try {
    logEvent(analytics, eventName, parameters);
  } catch (error) {
    console.warn('Error tracking event:', error);
  }
};

// Specific game events
export const gameEvents = {
  // Room events
  roomCreated: (settings: any) => trackGameEvent('room_created', {
    num_rounds: settings.numRounds,
    round_seconds: settings.roundSeconds,
    category: settings.category,
    allow_self_vote: settings.allowSelfVote,
    reveal_mode: settings.revealMode
  }),
  
  roomJoined: (playersCount: number) => trackGameEvent('room_joined', {
    players_count: playersCount
  }),
  
  // Game events
  gameStarted: (playersCount: number, totalRounds: number) => trackGameEvent('game_started', {
    players_count: playersCount,
    total_rounds: totalRounds
  }),
  
  gameCompleted: (playersCount: number, totalRounds: number, duration: number) => trackGameEvent('game_completed', {
    players_count: playersCount,
    total_rounds: totalRounds,
    duration_minutes: Math.round(duration / 60000)
  }),
  
  // Additional game-specific events
  gameAbandoned: (playersCount: number, roundsCompleted: number) => trackGameEvent('game_abandoned', {
    players_count: playersCount,
    rounds_completed: roundsCompleted
  }),
  
  playerDisconnected: (playersCount: number) => trackGameEvent('player_disconnected', {
    remaining_players: playersCount
  }),
  
  // Round events
  questionDisplayed: (roundIndex: number, category: string, isTemplate: boolean) => trackGameEvent('question_displayed', {
    round_index: roundIndex,
    category,
    is_template: isTemplate
  }),
  
  challengeDisplayed: (roundIndex: number, category: string) => trackGameEvent('challenge_displayed', {
    round_index: roundIndex,
    category,
    content_type: 'challenge'
  }),
  
  voteSubmitted: (roundIndex: number, responseTime: number) => trackGameEvent('vote_submitted', {
    round_index: roundIndex,
    response_time_seconds: Math.round(responseTime / 1000)
  }),
  
  // User engagement
  roomLeft: (reason: 'manual' | 'host_disconnect' | 'error') => trackGameEvent('room_left', {
    reason
  }),
  
  // Performance metrics
  loadTime: (pageType: string, loadTime: number) => trackGameEvent('page_load_time', {
    page_type: pageType,
    load_time_ms: loadTime
  })
};

// Error tracking
export const trackError = (error: string, context: string) => trackGameEvent('app_error', {
  error_message: error,
  context
});

// User properties (for segmentation)
export const setUserProperties = (properties: Record<string, string>) => {
  if (!analytics) return;
  
  try {
    // Set custom user properties for better segmentation
    console.log('User properties would be set:', properties);
    // Note: This would require importing setUserProperties from firebase/analytics
    // setUserProperties(analytics, { [key]: value });
  } catch (error) {
    console.warn('Error setting user properties:', error);
  }
};